import React from "react";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { AddPropertyFieldComponent } from "../property/PropertyField";
import { getFieldStatus } from "./common";

const RadioField = withStyles(
  {
    shrink: {
      transform: "scale(0.85)"
    },
    formControl: {
      position: "inherit"
    }
  },
  { name: "LcRadioField" }
)(
  ({
    classes = {},
    name,
    label: labelProp = name,
    options,
    row,
    disabled: disabledProp,
    value: valueProp,
    fast = true,
    FieldComponent = fast ? FastField : Field,
    j = 0
  }) => (
    <FieldComponent name={name}>
      {({ field, form }) => {
        const { error, hasError, disabled, label, value } = getFieldStatus(
          form,
          field,
          valueProp,
          labelProp,
          disabledProp
        );

        const opts = typeof options === "function" ? options(form) : options;
        const fieldVal = value === undefined || value === null ? "" : value;

        return (
          <FormControl>
            <Box width="100%">
              <InputLabel
                shrink
                error={hasError}
                disabled={disabled}
                classes={{
                  shrink: classes.shrink,
                  formControl: classes.formControl
                }}
              >
                {label}
              </InputLabel>
              <RadioGroup
                row={row}
                aria-label={label}
                name={name}
                className={classes.group}
                value={fieldVal}
                onChange={field.onChange}
                onBlur={field.onBlur}
                disabled={disabled}
              >
                {opts &&
                  opts.map(
                    ({
                      label: lbl,
                      value: val = lbl,
                      control = <Radio />,
                      extra = null
                    }) => {
                      if (typeof lbl === "function") {
                        lbl = lbl(val, form, field);
                      }
                      return (
                        <React.Fragment key={"radio-" + name + "-" + j++}>
                          <FormControlLabel
                            value={val}
                            control={control}
                            label={lbl}
                            disabled={disabled}
                          />
                          {extra}
                        </React.Fragment>
                      );
                    }
                  )}
              </RadioGroup>
              {hasError && (
                <FormHelperText error={hasError}>{error}</FormHelperText>
              )}
            </Box>
          </FormControl>
        );
      }}
    </FieldComponent>
  )
);

AddPropertyFieldComponent("radio", RadioField);

export default RadioField;
